export default __webpack_public_path__ + "static/media/instagram.d0d05523.svg";